import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { Observable } from "rxjs/Rx";
import { SxHttpService } from "./sxHttp.service";
import { EntityChildsContext } from "app/private/entity/entityWithChilds/model/EntityChildsContext";
import { PageList } from "../model/interfaces/pageList.interface";

@Injectable()
export class PageListService {
  private pageListServiceUrl = "api/menuItem";

  constructor(private http: Http, private sxHttp: SxHttpService) {}
  //#region standard persistence
  getAll(subscriptionCode,channelCode): Observable<PageList[]> {
    return this.sxHttp
      .get(`${this.pageListServiceUrl}/${subscriptionCode}/${channelCode}`)
      .map((response) => {
        return response.json().data as PageList[]
      });
  }

  getById(idPageList: string): Observable<PageList> {
    return this.sxHttp
      .get(`${this.pageListServiceUrl}/${idPageList}`)
      .map((response) => response.json().data as PageList);
  }

  delete(idPageList: string): Promise<Boolean> {
    return this.sxHttp
      .delete(`${this.pageListServiceUrl}/${idPageList}`)
      .toPromise()
      .then((result) => result.json().data);
  }

  create(model: PageList): Promise<any> {
    return this.sxHttp
      .post(this.pageListServiceUrl, model)
      .toPromise()
      .then((response) => {
        return response.json().data;
      });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/pageList.service.ts